<!--Par défaut affichage de toutes les personnes classées par nom-->
<h2>Personnes</h2>
<!--
<button class="btn btn-outline-info">Créer une nouvelle personne <i class="material-icons">add_circle_outline</i></button>
-->
<table class="table table-sm table-bordered">
    <thead>
        <th (click)="sortby('Civilite')">Civilité</th>
        <th (click)="sortby('Nom')">Nom</th>
        <th (click)="sortby('Prenom')">Prénom</th>
    </thead>
    <!--Début boucle ligne-->
    <tr routerLink="/person" routerLinkActive="active">
        <td>Monsieur</td>
        <td>Abadie</td>
        <td>Philippe</td>
    </tr>
    <!--Fin boucle ligne-->
    <tr>
        <td>Monsieur</td>
        <td>ABBIATECI</td>
        <td>Bruno</td>
    </tr>
    <tr>
        <td>Madame</td>
        <td>ABBIATECI</td>
        <td>Elisabeth</td>
    </tr>
    <tr>
        <td>Madame</td>
        <td>ABSALON</td>
        <td>Yasmina</td>
    </tr>
    <tr>
        <td>Monsieur</td>
        <td>ADAM</td>
        <td>Eric</td>
    </tr>
    <tr>
        <td>Monsieur</td>
        <td>Agache</td>
        <td>Patrick</td>
    </tr>
</table>
